import { useState, useEffect } from 'react'
import { getProjectById } from '@/services/projects'

export const useProjectDetail = (id) => {
  const [project, setProject] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!id) return

    const fetchProject = async () => {
      try {
        setLoading(true)
        const data = await getProjectById(id)
        setProject(data)
        setError(null)
      } catch (err) {
        setError(err.message)
        setProject(null)
      } finally {
        setLoading(false)
      }
    }

    fetchProject()
  }, [id])

  return { project, loading, error }
}
